<div class="border flex flex-col lg:flex-row">
  <!-- Main Canvas Area -->
  <div
    class="w-full lg:w-[70%] border-2 example-boundary overflow-hidden relative"
    id="canvas-container"
    #canvasContainer
  >
    <!-- POWERTRAIN CANVAS ITEMS -->
    <div class="mb-4 w-100 h-100" *ngIf="isPowerTrain">
      <div
        class="cursor-move border"
        *ngFor="let item of powertrainCanvasItems"
        [ngStyle]="{
          top: '0px',
          left: '0px',
          width: '100%',
          height: '100%'
        }"
        [ngClass]="{
          'border-4 border-red-500': selectedAsset.id == item.id
        }"
        id="asset-{{ item.id }}"
        (click)="onCanvasItemClick(item)"
      >
        <img [src]="item.src" class="w-full h-full img" />
        <div
          *ngFor="let sensor of item.sensors; let i = index"
          (click)="onPowertrainSensorClick(item, i)"
          cdkDrag
          cdkDragBoundary="#asset-{{ item.id }}"
          (cdkDragEnded)="onPowertrainSensorDragEnd($event, sensor)"
          class="absolute border rounded-lg bg-white flex items-center justify-center"
          [ngStyle]="{
            top: sensor.yPercentage?sensor.yPercentage + '%':'0px',
            left: sensor.xPercentage?sensor.xPercentage + '%':'0px',
            width: '50px',
            height: '30px',
            fontSize: '10px'
          }"
          [ngClass]="{
            'select_sensor': powertrainSelectedSensor.id == sensor.id
          }"
        >
          <!-- {{ sensor.sensor_number === 0 ? "B" : sensor.sensor_number }} -->
          <!-- {{ sensor.sensorMarker }} -->
          {{ sensor.sensorDNames  }}
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <!-- OLD BUTTONS -->
    <!-- <div class="row">
      <button class="btn btn-secondary" (click)="selectPowerTrainType(true)">
        Powertrains
      </button>
      <button
        *ngIf="isPowerTrain"
        class="btn btn-success"
        (click)="addPowerTrainSensor()"
      >
        Add Sensor
      </button>
      <button
        *ngIf="isPowerTrain"
        class="btn btn-danger"
        (click)="openPowertrainNameModalBox()"
      >
        Save Template
      </button>
      <button
        *ngIf="isPowerTrain"
        class="btn btn-danger"
        (click)="resetOldPowerTrain()"
      >
        Reset Template
      </button>
      <button
          *ngIf="powertrainSelectedSensor.assetType && isPowerTrain"
          class="btn btn-warning"
          (click)="deleteCurrentPowertrainSensor()"
        >
          Delete current sensor
        </button>
      <button class="btn btn-info" (click)="deleteCanvasSensor()">
        Delete Sensors
      </button>
      <button *ngIf="!isPowerTrain" class="btn btn-light" (click)="addSensor()">
        Add Sensor
      </button>
      <button
        *ngIf="!isPowerTrain"
        class="btn btn-dark"
        (click)="openPowertrainNameModalBox()"
      >
        Save Template
      </button>
    </div> -->
    <div class="button-section">
    <h2>Powertrains</h2>
    <div class="buttons ">
      <!-- Add Sensor Button -->
      <button mat-raised-button color="warn" (click)="goBackToDashboard()">
        <i class="fas fa-plus"></i>
        Cancel
      </button>
      <button mat-raised-button color="primary" (click)="addPowerTrainSensor()">
        <i class="fas fa-plus"></i>
        Add Sensor
      </button>
      <!-- Save Template Button -->
      <button mat-raised-button color="primary" (click)="openPowertrainNameModalBox()">
        <i class="fas fa-save"></i>
        Save Template
      </button>
      <!-- Reset Template Button -->
      <button mat-raised-button color="warn" (click)="resetOldPowerTrain()">
        <i class="fas fa-sync"></i>
        Reset Template
      </button>
      <!-- Delete Sensors Button -->
      <button mat-raised-button color="warn" (click)="deleteCanvasSensor()">
        <i class="fas fa-trash"></i>
        Delete Sensors
      </button>
    </div>
  </div>
  <div class="" style="display:flex;flex-direction: column;">
    <!-- Sidebar -->
    <div
      *ngIf="!isPowerTrain"
      class="row w-full lg:w-[30%] border-2 p-4 space-y-4"
    >
      <div class="grid grid-cols-2 gap-4">
        <img
          *ngFor="let image of images"
          [src]="image.src"
          [alt]="image.alt"
          (click)="addImageToCanvas(image)"
          class="w-20 h-20 cursor-pointer hover:shadow-md"
        />
      </div>
    </div>
    <!-- POWERTRAIN IMAGES FROM DATABASE -->
    <div
      *ngIf="isPowerTrain"
      class="row w-full lg:w-[30%] border-2 p-4 space-y-4"
    >
      <div
        class="grid grid-cols-2 gap-4"
        style="height: 30vh; overflow: scroll"
      >
        <img
          *ngFor="let image of powerTrainImages"
          [src]="image.image_path"
          [alt]="image.image_alt"
          (click)="addImageToPowerTrainCanvas(image)"
          class="cursor-pointer hover:shadow-md"
          style="width: 70%"
        />
      </div>
    </div>
    <!-- Powertrain Sensors Info-->
    <div class="asset-details-box">
      <!-- Asset Type -->
      <div class="detail-group">
        <span class="detail-label">Asset Type</span>
        <span class="detail-value">{{ powertrainSelectedSensor.assetType }}</span>
      </div>
      
      <!-- Sub Type -->
      <div class="detail-group">
        <span class="detail-label">Sub Type</span>
        <span class="detail-value">{{ powertrainSelectedSensor.subType }}</span>
      </div>
    
      <!-- Asset Marker -->
      <div class="detail-group">
        <span class="detail-label">Asset Marker</span>
        <span class="detail-value highlight">{{ powertrainSelectedSensor.assetMarker }}</span>
      </div>
    
      <!-- Asset Display Name -->
      <div class="detail-group">
        <span class="detail-label">Asset Display Name</span>
        <span class="detail-value highlight">{{ powertrainSelectedSensor.sensorDNames }}</span>
      </div>
      <!-- Asset Name -->
      <div class="detail-group">
        <span class="detail-label">Sensor Name</span>
        <span class="detail-value highlight">{{ powertrainSelectedSensor.sensorMarker }}</span>
      </div>
    </div>
  </div>

  </div>
</div>
<br />


<app-powertrain-modal
  [type]="'motor_selection'"
  [data]="{}"
  *ngIf="openModal"
  (closeBox)="closeBox($event)"
></app-powertrain-modal>

<app-powertrain-modal
  [type]="'asset_selection'"
  [data]="{ isMaster: powerTrainSensorsNumber }"
  *ngIf="openPowertrainSensorModal"
  (closeBox)="closePowerTrainSensorBox($event)"
></app-powertrain-modal>

<app-powertrain-modal
  [type]="'powertrain_name'"
  [data]="{name:existingPowertrainObj.powertrainName}"
  *ngIf="openPowertrainNameModal"
  (closeBox)="inputPowertrainName($event)"
></app-powertrain-modal>
